(function ($) {

    $.fn.extend({

        sorsBanner: function (options) {
            var defaults = {
                maxWidth: 1920,
                maxHeight: 554,
                evenColor: "#ccc",
                oddColor: "#eee"
            };

            var options = $.extend(defaults, options);
            var firstWinWidth = $(window).width();

            return this.each(function () {

                var o = options;
                var obj = $(this);
                var items = $("div.carousel-inner > div.item", obj);
                var itemsleft = 0;

                $(obj).css("max-width", o.maxWidth).css("max-height", o.maxHeight);

                function onResize() {

                    var winWidth = $(window).width();

                    $(items).each(function () {

                        var activeItem = $(".item.active", obj);
                        var img = $("img.CarouselImg", activeItem);

                        var ow = img.data("ow");
                        var oh = img.data("oh");
                        var xw = img.width();
                        var xh = img.height();

                        if (xw == 0) {
                            xw = ow;
                        }

                        if (isMobile) {
                            if (xw == 100) {
                                xw = 500;
                            }
                        }

                        if (xh == 0) {
                            xh = oh;
                        }

                        //Banner Text Resize
                        $(".BannerText", activeItem).each(function () {
                            var ResizeRatio = (ow / xw);

                            var AW = $(this).data("w");
                            var AH = $(this).data("h");
                            var AX = $(this).data("x");
                            var AY = $(this).data("y");
                            var AZ = $(this).data("z");
                            var AFC = $(this).data("font-color");
                            var AFS = $(this).data("font-size");
                            var AFSt = $(this).data("font-style");
                            var AFW = $(this).data("font-weight");

                            $(this).css({
                                "width": AW / ResizeRatio,
                                "height": AH / ResizeRatio,
                                "margin-top": AY / ResizeRatio,
                                "margin-left": AX / ResizeRatio,
                                "z-index": AZ,
                                "color": AFC,
                                "font-size": AFS / ResizeRatio,
                                "font-style": AFSt,
                                "font-weight": AFW
                            });
                        });

                    });

                }

                $(window).resize(function myfunction() {
                    onResize();
                });

                onResize();

                $('img.CarouselImg').on('load', function () {
                    onResize();
                });

                $(obj).data('resize-fn', onResize);

            });
        }
    });

})(jQuery);

function PromotionViewGtagDatalayer() {
    var bannerElements = $(".container .SBanner");

    if (bannerElements.length === 0)
        return;

    var itemsArray = []; // Ürünleri saklamak için dizi

    bannerElements.each(function (index, element) {
        var bannerRootValue = $(element).find('.BannerText');
        var BannerID = bannerRootValue.attr('data-BannerID');
        var BannerName = bannerRootValue.attr('data-BannerName');

        if (BannerName === "" || BannerName === undefined) {
            BannerName = null;
        }

        if (BannerID === "" || BannerID === undefined) {
            BannerID = null;
        }

        itemsArray.push({
            promotion_id: BannerID,
            promotion_name: BannerName,
            creative_name: 'JMK',
            creative_slot: BannerName,
            index: index
        });
    });

    if (itemsArray.length === 0)
        return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'view_promotion',
        ecommerce: {
            items: itemsArray
        }
    });

    var scrolled_val = 0;
    $(window).scroll(function () {
        scrolled_val = $(document).scrollTop().valueOf();
        scrolled_val = parseInt(scrolled_val);

        bannerElements.each(function (index, element) {
            var position = $(element).offset();
            position = parseInt(position.top);

            if (scrolled_val > position - 200) {
                if (!$(element).hasClass('datalayerpush')) {
                    $(element).addClass('datalayerpush');

                    var a = $(element).find('.BannerText');
                    var BannerID = a.attr('data-BannerID');
                    var BannerName = a.attr('data-BannerName');

                    if (BannerName === "" || BannerName === undefined) {
                        BannerName = null;
                    }

                    if (BannerID === "" || BannerID === undefined) {
                        BannerID = null;
                    }

                    itemsArray.push({
                        promotion_id: BannerID,
                        promotion_name: BannerName,
                        creative_name: 'JMK',
                        creative_slot: BannerName,
                        index: index
                    });
                }
            }
        });
    });
}


function PromotionClickGtagDatalayer() {
    $('.BannerText').click(function () {
        var a = $(this);
        var GosterimYeri = a.attr('data-gosterimyeri');
        var BannerID = a.attr('data-BannerID');
        var BannerName = a.attr('data-BannerName');

        if (BannerName == "" || BannerName == undefined) {
            BannerName = null;
        }

        if (BannerID == "" || BannerID == undefined) {
            BannerID = null;

        }

        if (GosterimYeri == "" || GosterimYeri == undefined) {
            GosterimYeri = null;
        }

        var itemsObject = {
            promotion_id: BannerID,
            promotion_name: BannerName,
            creative_name: 'JMK',
            creative_slot: BannerName,
            index:0
        };

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'select_promotion',
            ecommerce: {
                items: [itemsObject]
            }
        });

       //alert(JSON.stringify(itemsObject));
    });
}

$(document).ready(function () {

    PromotionViewGtagDatalayer();
    PromotionClickGtagDatalayer();

    $(".SBanner").sorsBanner({
        maxWidth: "auto",
        maxHeight: "auto"
    });

    $(".SBanner").hammer().on("swiperight", function (e) {

        $(this).carousel('prev');
        e.stopPropagation();
        e.preventDefault();
    });

    $(".SBanner").hammer().on("swipeleft", function (e) {

        $(this).carousel('next');
        e.stopPropagation();
        e.preventDefault();
    });

    $('.SBanner.carousel').on('slide.bs.carousel', function (evt) {

        //console.log($(evt.relatedTarget));
        //var imgItem = $(this).find(".carousel-inner .item.active img");

        var imgItem = $(evt.relatedTarget).find("img");

        if (imgItem) {
            var datasrc = imgItem.attr("data-src");

            if (datasrc) {
                imgItem.attr("src", datasrc);
            }
        }
    });
    $('.SBanner.carousel').on('slid.bs.carousel', function (e) {
        var $carousel = $(this);
        var $newActiveImg = $(e.relatedTarget).find("img.CarouselImg");

        if ($newActiveImg.length > 0) {
            // Eğer zaten yüklenmişse hemen çalıştır
            if ($newActiveImg[0].complete) {
                var resizeFn = $carousel.data('resize-fn');
                if (typeof resizeFn === 'function') {
                    resizeFn();
                }
            } else {
                // Değilse, yüklenince çalıştır
                $newActiveImg.one("load", function () {
                    var resizeFn = $carousel.data('resize-fn');
                    if (typeof resizeFn === 'function') {
                        resizeFn();
                    }
                });
            }
        }
    });


});


// Resimleri yükleyen fonksiyon
function loadVisibleImages() {

    var windowHeight = $(window).height();

    var windowTop = $(window).scrollTop();

    var windowBottom = windowTop + windowHeight;

    $(".SBanner img").each(function () {

        var imgTop = $(this).offset().top;

        var imgBottom = imgTop + $(this).height();

        if (imgBottom >= windowTop && imgTop <= windowBottom) {

            var datasrc = $(this).attr("data-src");

            if (datasrc) {

                $(this).attr("src", datasrc);

                $(this).removeAttr("data-src");

            }
        }
    });
}

// Sayfa yüklendiğinde ve aşağı doğru kaydırıldığında resimleri yükle
$(window).on("load scroll", function () {

    loadVisibleImages();

});